import React from "react"
import { Box, Chip, Paper, Stack, Typography } from "@mui/material"

export const getGroupApplications = (group) => Array.isArray(group?.latestApplications)
  ? group.latestApplications.filter(Boolean)
  : group?.latestApplication ? [group.latestApplication] : []

const GroupApplications = ({ applications = [], compact = false }) => (
  <Box sx={compact ? { height: 182, minHeight: 0 } : undefined}>
    <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
      <Typography variant="subtitle2">Applications</Typography>
      <Chip size="small" label={applications.length} />
    </Stack>
    {!applications.length ? <Typography variant="body2" color="text.secondary">No applications assigned.</Typography> :
      <Stack spacing={1} sx={{ height: compact ? 150 : undefined, maxHeight: compact ? 150 : 360, overflowY: "auto", scrollbarGutter: compact ? "stable" : undefined, pr: 0.5 }}>
        {applications.map((app, index) => <Paper variant="outlined" key={`${app.applicationId ?? app.appId}-${index}`} sx={{ p: 1.5, minWidth: 0, borderRadius: 2, flexShrink: 0 }}>
          <Typography variant="body2" fontWeight={600} sx={{ overflowWrap: "anywhere" }}>{app.appName || app.appId || "Unnamed application"}</Typography>
          <Typography variant="caption" color="text.secondary" sx={{ display: "block", overflowWrap: "anywhere" }}>{app.appId || "Package name unavailable"}</Typography>
          <Stack direction="row" useFlexGap flexWrap="wrap" spacing={1} sx={{ mt: 1 }}>
            <Chip size="small" label={`Version: ${app.appVersion ?? "—"}`} sx={{ maxWidth: "100%" }} />
            <Chip size="small" color="primary" variant="outlined" label={`Installs: ${app.totInstallCount ?? "—"}`} />
          </Stack>
          {!compact && <Box component="dl" sx={{ display: "grid", gridTemplateColumns: "repeat(2, minmax(0, 1fr))", gap: 1, mt: 1.5, mb: 0 }}>
            {[["Application ID", app.applicationId], ["Version code", app.versionCode], ["Assigned at", app.assignedAt]].map(([label, value]) => <Box key={label}>
              <Typography component="dt" variant="caption" color="text.secondary">{label}</Typography>
              <Typography component="dd" variant="body2" sx={{ m: 0, overflowWrap: "anywhere" }}>{value ?? "—"}</Typography>
            </Box>)}
          </Box>}
        </Paper>)}
      </Stack>}
  </Box>
)

export default GroupApplications
